import React, { useState, useEffect } from 'react';
import './style.css';

const MessageDetailsPanel = ({ 
    isOpen, 
    onClose, 
    messageDetails, 
    loadingDetails,
    formatDate 
}) => {
    const [menuWidth, setMenuWidth] = useState(400);
    const [isResizing, setIsResizing] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
        } else {
            // Затримка для анімації закриття
            const timer = setTimeout(() => setIsVisible(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    const handleMouseDown = (e) => {
        setIsResizing(true);
        e.preventDefault();
    };

    const handleMouseUp = () => {
        setIsResizing(false);
    };

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isResizing) return;
            
            const containerRect = document.querySelector('.ai-chat-container').getBoundingClientRect();
            const newWidth = containerRect.right - e.clientX;
            
            if (newWidth >= 300) {
                setMenuWidth(newWidth);
            }
        };

        if (isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isResizing]);

    if (!isVisible) return null;

    return (
        <div className={`message-details-overlay ${isOpen ? 'open' : 'closing'}`}>
            <div 
                className={`message-details-menu ${isOpen ? 'open' : 'closing'}`}
                style={{ width: `${menuWidth}px` }}
            >
                <div 
                    className="resize-handle"
                    onMouseDown={handleMouseDown}
                />
                <div className="details-header">
                    <h4>Деталі повідомлення</h4>
                    <button 
                        className="close-button"
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>
                <div className="details-content">
                    {loadingDetails ? (
                        <div className="loading-details">
                            <div className="loading-spinner"></div>
                            <span>Завантаження...</span>
                        </div>
                    ) : messageDetails ? (
                        <div className="message-detail-sections">
                            <div className="detail-section">
                                <h5>Відповідь:</h5>
                                <div className="detail-text">{messageDetails.content}</div>
                            </div>
                            
                            {messageDetails.doc_content && (
                                <div className="detail-section">
                                    <h5>Документація:</h5>
                                    <div className="detail-text" dangerouslySetInnerHTML={{ __html: messageDetails.doc_content }} />
                                </div>
                            )}
                            
                            {messageDetails.ai_note_content && (
                                <div className="detail-section">
                                    <h5>AI нотатки:</h5>
                                    <div className="detail-text" dangerouslySetInnerHTML={{ __html: messageDetails.ai_note_content }} />
                                </div>
                            )}
                            
                            <div className="detail-section">
                                <h5>Тип відправника:</h5>
                                <div className="detail-text">{messageDetails.sender_type}</div>
                            </div>
                            
                            {messageDetails.used_tools && messageDetails.used_tools.length > 0 && (
                                <div className="detail-section">
                                    <h5>Використані інструменти:</h5>
                                    <div className="tools-detail-list">
                                        {messageDetails.used_tools.map((tool, index) => (
                                            <span key={index} className="tool-detail-badge">
                                                {tool}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            <div className="detail-section">
                                <h5>Створено:</h5>
                                <div className="detail-text">{formatDate(messageDetails.created_at)}</div>
                            </div>
                        </div>
                    ) : (
                        <div className="error-details">
                            <span>⚠️ Помилка завантаження деталей</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MessageDetailsPanel;
